import Head from 'next/head'
import { BaseLayout } from '~/src/components/shared/layout'

import { SectionHeader, PageMetaBanner } from '~/src/components/shared'

import { PageMetaContextProvider } from '~/src/contexts'
import { PageId } from '~/src/generated/graphql'
import { useCategoriesContext } from '~/src/contexts'
import { ORIGINALS_ROOT_CATEGORY } from '~/src/const'
import { getTitle } from '~/src/utils'
import { PostCoverType } from '~/src/components/post/PostCard'
import { PagePosts } from '~/src/components/page/PagePosts'

export default function Originals() {
  const { categories } = useCategoriesContext()
  const rootCategory = categories.find(category => category?.categoryId === ORIGINALS_ROOT_CATEGORY)

  if(!rootCategory) return null

  return (
    <BaseLayout>
      <Head>
        <title>{getTitle('ORIGINALS')}</title>
      </Head>
      <PageMetaContextProvider pageId={PageId.Originals}>
        <PageMetaBanner />
        <SectionHeader
          title={rootCategory.name}
          description={rootCategory.description ?? ''}
          variant='primary'
          className='my-24'
        />

        <PagePosts coverType={PostCoverType.Square} />

        <div className='mt-24' />
      </PageMetaContextProvider>
    </BaseLayout>
  )
}
